import { styled } from "goober";

export const InfoContainer = styled("div")`
  position: relative;

  display: flex;
  .info {
    flex: 1;
    .top {
      display: flex;
      padding-bottom: var(--sp-9);
    }
    .lower {
      display: flex;
      justify-content: space-between;
    }
  }
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: var(--sp-1_5);
    flex: 1;
    .name-section {
      justify-content: space-between;
      .name-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: var(--sp-3);
        .tag {
          display: flex;
          width: var(--sp-10);
          height: var(--sp-6);
        }
      }
      .ellipsis {
        position: relative;
        color: var(--shade0-25);
        width: var(--sp-4);
        font-size: var(--sp-4_5);
        &:hover {
          cursor: pointer;
          color: var(--shade0-50);
        }
        .menu {
          position: absolute;
          top: calc(var(--sp-6) * -1);
          right: calc(var(--sp-4) * -1);
          padding: var(--sp-4) var(--sp-5_5);
          border-radius: var(--br);
          background-color: var(--shade10);
          width: 232px;
          color: var(--shade0);
          transition: var(--transition);
          &:hover {
            background-color: var(--shade6);
          }
          .option {
            display: flex;
            gap: var(--sp-4);
            align-items: center;
            .icon {
              color: var(--shade2);
            }
          }
        }
      }
    }
  }

  .meta-data {
    display: flex;
    flex: 1;
    justify-content: space-between;
    max-width: 600px;
    padding-right: var(--sp-12_5);
  }

  .buttons {
    display: flex;
    position: relative;
    top: var(--sp-3);
    gap: var(--sp-2);
    .edit {
      width: var(--sp-20);
      height: var(--sp-9);
    }
  }

  .username {
    display: flex;
    color: var(--shade2);
    gap: var(--sp-1_5);
    padding-bottom: var(--sp-1_5);
  }

  .edit-info {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .dob {
    .month {
      margin-right: var(--sp-1);
      width: 100px;
    }
    .day {
      margin-right: var(--sp-1);
      width: 80px;
    }
    .year {
      margin-right: var(--sp-1);
      width: 100px;
    }
  }
`;

export const ImageContainer = styled("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--sp-16);
  height: var(--sp-16);
  margin-right: var(--sp-6);
  color: var(--shade2);

  & > svg {
    z-index: 1;
  }

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--shade6);
    border-radius: 50%;
    filter: drop-shadow(0px 4px 12px rgba(7, 8, 12, 0.25))
      drop-shadow(0px 12px 24px rgba(7, 8, 12, 0.25));
  }
`;
